import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// @azure/msal-browser v5 changed popup/redirect transport: the redirect URI
// page must invoke broadcastResponseToMainFrame() from the redirect-bridge
// subpath when an auth response is present in the URL. The bridge handles:
//   - Popup flow: BroadcastChannel.postMessage to opener, then window.close().
//   - Redirect flow: cache payload in sessionStorage, navigate to saved origin
//     URI; on that page, handleRedirectPromise() reads from sessionStorage.
// Both responses include state= in the URL (hash or query), so that's the trigger.
function hasMsalAuthResponse(): boolean {
  return (
    window.location.hash.includes('state=') ||
    window.location.search.includes('state=')
  );
}

async function processBridgeIfNeeded(): Promise<'popup-closed' | 'redirect-navigated' | 'none'> {
  if (!hasMsalAuthResponse()) return 'none';
  const isPopup = !!window.opener && window.opener !== window;
  document.body.innerHTML =
    '<p style="font-family:system-ui;padding:2rem;text-align:center;color:#475569;">Completing sign-in…</p>';
  try {
    const bridge = await import('@azure/msal-browser/redirect-bridge');
    await bridge.broadcastResponseToMainFrame();
  } catch (err) {
    console.warn('[msal] redirect bridge failed:', err);
    return 'none';
  }
  return isPopup ? 'popup-closed' : 'redirect-navigated';
}

processBridgeIfNeeded().then(outcome => {
  if (outcome === 'popup-closed') return;
  bootstrapApplication(App, appConfig).catch(err => console.error(err));
});
